var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as shiftAction from '../actions/shift.action';
import * as freelancerAction from '../../../freelancers/store/actions/freelancer.action';
import { switchMap, mergeMap, withLatestFrom, filter, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';
import { ShiftsService } from '../../shifts.service';
var ShiftEffect = /** @class */ (function () {
    function ShiftEffect(actions, shiftService, store) {
        var _this = this;
        this.actions = actions;
        this.shiftService = shiftService;
        this.store = store;
        this.rotateShift = this.actions.ofType(shiftAction.ROTATE_SHIFT)
            .pipe(map(function (action) { return action.payload; }), mergeMap(function (shiftId) {
            return _this.shiftService.rotateShift(shiftId)
                .map(function (r) { return new shiftAction.RotateShiftSuccess(r); })
                .catch(function (e) { return of(new shiftAction.RotateShiftError(e)); });
        }));
        this.getAllShifts = this.actions.ofType(shiftAction.GET_ALL_SHIFTS)
            .pipe(switchMap(function () {
            _this.store.dispatch(new freelancerAction.GetAllFreelancers());
            return _this.shiftService.getAllShifts()
                .map(function (res) {
                res.forEach(function (shift) { return _this.shiftModded(shift); });
                return new shiftAction.GetAllShiftsSuccess(res);
            })
                .catch(function (error) { return of(new shiftAction.GetAllShiftsError(error)); });
        }));
        this.getShift = this.actions.ofType(shiftAction.GET_SHIFT)
            .pipe(withLatestFrom(
        // select shifts.
        this.store.select(function (state) { return state.shiftsFeature.shifts.entities; }), function (action, shifts) {
            // if no shifts present, proceed for API.
            if (isNullOrUndefined(shifts)) {
                return action;
            }
            else {
                // shifts exists in store.
                var shift = shifts.filter(function (b) { return b.id === action.payload; })[0];
                if (!!shift) {
                    // if required shift is present in store, then return;
                    return undefined;
                }
                else {
                    // if required shifts not present in store, then proceed for API.
                    return action;
                }
            }
        }), filter(function (action) { return !!action; }), mergeMap(function (action) {
            return _this.shiftService.getShift(action.payload)
                .map(function (res) { return new shiftAction.GetShiftSuccess(_this.shiftModded(res)); })
                .catch(function (error) { return of(new shiftAction.GetShiftError(error)); });
        }));
    }
    ShiftEffect.prototype.shiftModded = function (shift) {
        var _this = this;
        shift.moddedBooked = [];
        shift.moddedRequested = [];
        shift.moddedHold = [];
        shift.moddedCase = [];
        if (shift.bookedFreelancers) {
            shift.bookedFreelancers.forEach(function (freelancerId) {
                _this.store.select(function (state) { return state.freelancersFeature.freelancers.users; }).subscribe(function (users) {
                    shift.moddedBooked.push(users.filter(function (user) { return user.id === freelancerId; })[0]);
                });
            });
        }
        if (shift.requestedFreelancers) {
            shift.requestedFreelancers.forEach(function (freelancerId) {
                _this.store.select(function (state) { return state.freelancersFeature.freelancers.users; }).subscribe(function (users) {
                    shift.moddedRequested.push(users.filter(function (user) { return user.id === freelancerId; })[0]);
                });
            });
        }
        if (shift.onHold) {
            shift.onHold.forEach(function (freelancerId) {
                _this.store.select(function (state) { return state.freelancersFeature.freelancers.users; }).subscribe(function (users) {
                    shift.moddedHold.push(users.filter(function (user) { return user.id === freelancerId; })[0]);
                });
            });
        }
        if (shift.inCase) {
            shift.inCase.forEach(function (freelancerId) {
                _this.store.select(function (state) { return state.freelancersFeature.freelancers.users; }).subscribe(function (users) {
                    shift.moddedCase.push(users.filter(function (user) { return user.id === freelancerId; })[0]);
                });
            });
        }
        return shift;
    };
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ShiftEffect.prototype, "rotateShift", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ShiftEffect.prototype, "getAllShifts", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ShiftEffect.prototype, "getShift", void 0);
    return ShiftEffect;
}());
export { ShiftEffect };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/shifts/store/effects/shift.effect.ts.pre-build-optimizer.js